var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    { staticClass: "loading-spinner" },
    _vm._l(_vm.circles, function(item, index) {
      return _c("circle", {
        key: index,
        attrs: {
          cx: _vm.circlePositions[index] && _vm.circlePositions[index].x,
          cy: _vm.circlePositions[index] && _vm.circlePositions[index].y,
          r: item.radius,
          fill: item.color
        }
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }